import { DEFAULT_EMPTY_ADDRESS_OBJECT, DEFAULT_EMPTY_CONTACT_PERSON_OBJECT } from '@/modules/base/util/constants'
import SupplierModel from '@/modules/supplier/components/edit/model/supplier-model'

// actions
const ACTION_PREFIX = 'supplier/edit'
const RESET_STATE = `${ACTION_PREFIX}/resetState`
const UPDATE_SUPPLIER_DATA = `${ACTION_PREFIX}/updateSupplierData`
const OPEN_ADDRESS_FORM_MODAL = `${ACTION_PREFIX}/openAddressFormModal`
const CLOSE_ADDRESS_FORM_MODAL = `${ACTION_PREFIX}/closeAddressFormModal`
const OPEN_CONTACT_PERSON_MODAL = `${ACTION_PREFIX}/openContactPersonModal`
const CLOSE_CONTACT_PERSON_MODAL = `${ACTION_PREFIX}/closeContactPersonModal`
const SET_SELECTED_ADDRESS = `${ACTION_PREFIX}/setSelectedAddress`
const SET_SELECTED_CONTACT_PERSON = `${ACTION_PREFIX}/setSelectedContactPerson`

// reducer
const initialState = {
  supplier: new SupplierModel(),
  selectedAddress: DEFAULT_EMPTY_ADDRESS_OBJECT,
  selectedContactPerson: DEFAULT_EMPTY_CONTACT_PERSON_OBJECT,
  addressFormModalOpen: false,
  contactPersonModalOpen: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_ADDRESS_FORM_MODAL:
      const { selectedAddress = state.selectedAddress, suppressModal = false } = action
      return {
        ...state,
        selectedAddress,
        addressFormModalOpen: !suppressModal,
      }

    case CLOSE_ADDRESS_FORM_MODAL:
      return {
        ...state,
        selectedAddress: DEFAULT_EMPTY_ADDRESS_OBJECT,
        addressFormModalOpen: false,
      }

    case OPEN_CONTACT_PERSON_MODAL:
      const { selectedContactPerson = state.selectedContactPerson } = action
      return {
        ...state,
        selectedContactPerson,
        contactPersonModalOpen: true,
      }

    case CLOSE_CONTACT_PERSON_MODAL:
      return {
        ...state,
        selectedContactPerson: DEFAULT_EMPTY_CONTACT_PERSON_OBJECT,
        contactPersonModalOpen: false,
      }

    case SET_SELECTED_ADDRESS: {
      const { selectedAddress = state.selectedAddress } = action
      return {
        ...state,
        selectedAddress,
        addressFormModalOpen: false,
      }
    }

    case SET_SELECTED_CONTACT_PERSON: {
      const { selectedContactPerson = state.selectedContactPerson } = action
      return {
        ...state,
        selectedContactPerson,
      }
    }

    case UPDATE_SUPPLIER_DATA:
      const { supplier } = action
      const newSupplier = new SupplierModel({ ...state.supplier, ...supplier })
      return { ...state, supplier: newSupplier }

    case RESET_STATE:
      return initialState

    default:
      return state
  }
};

// action creators
export const openAddressFormModal = (selectedAddress, suppressModal) => ({
  type: OPEN_ADDRESS_FORM_MODAL,
  selectedAddress,
  suppressModal,
})

export const closeAddressFormModal = () => ({
  type: CLOSE_ADDRESS_FORM_MODAL,
})

export const openContactPersonModal = (selectedContactPerson) => ({
  type: OPEN_CONTACT_PERSON_MODAL,
  selectedContactPerson,
})

export const closeContactPersonFormModal = () => ({
  type: CLOSE_CONTACT_PERSON_MODAL,
})

export const setSelectedAddress = (selectedAddress) => ({
  type: SET_SELECTED_ADDRESS,
  selectedAddress,
})

export const setSelectedContactPerson = (selectedContactPerson) => ({
  type: SET_SELECTED_CONTACT_PERSON,
  selectedContactPerson,
})

export const updateSupplierData = (data) => ({
  type: UPDATE_SUPPLIER_DATA,
  supplier: data,
})

export const resetState = () => ({
  type: RESET_STATE,
})
